import { render } from "./generalReport.vue?vue&type=template&id=361a5928"
import script from "./generalReport.vue?vue&type=script&lang=js"
export * from "./generalReport.vue?vue&type=script&lang=js"

import "./generalReport.vue?vue&type=style&index=0&id=361a5928&lang=scss"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__